import React, {Component} from 'react';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import ReactModal from 'react-modal';
import {Validators, FormBuilder, FieldControl, FieldGroup} from 'react-reactive-form';
import renderers from './forms/renderers';
import ReactTooltip from 'react-tooltip';


class CreateProgress extends Component {
    render() {
        return (
            <span className="kbedit-updating">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Creating ...
            </span>
        );
    }
}

class CustomEntityCreateDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onScrollTo = this.onScrollTo.bind(this);
        this.updateHeightDimensions = this.updateHeightDimensions.bind(this);
        this.initForm = this.initForm.bind(this);

        this.state = {
            height: 0,
            error: null,
            creating: false,
            entityType:'',
            label:''
        };
    };

    initForm() {
        this.myForm = FormBuilder.group({
            patternName:['', [Validators.required, Validators.minLength(3)]],
            entityType:['', [Validators.required, Validators.pattern(validation.customTypePattern), Validators.minLength(3)]],
            description:[''],
            extractionConfidence:[.95, [Validators.required, Validators.min(0), Validators.max(1)]],
            pattern: ['', [Validators.required]],
        });
    }

    componentDidMount() {
        ReactModal.setAppElement('#rm_CustomEntityCreateDialog');
        this.updateHeightDimensions();
        this.initForm();
    }

    componentWillReceiveProps(newProps) {
        if (this.myForm) {
            this.initForm();
        }
    }

    updateHeightDimensions() {
        this.setState({
            height: window.innerHeight - 75 - (window.innerHeight / 5)
        })
    }

    close(cancelled=true) {
        this.setState({
            creating: false,
            error: null
        },() => {
            if (this.props.onCreate) {
                this.props.onCreate(cancelled);
            }
        })
    };


    onSubmit(e) {
        e.preventDefault();
        this.setState({
            creating: true
        }, ()=> {
            if (this.myForm.valid) {

                const patternConfig = Object.assign({}, this.myForm.getRawValue());
                // Remove all empty fields from the object
                validation.removeEmptyItems(patternConfig)
                const patternName = patternConfig.patternName;
                delete patternConfig.patternName;
                const data = {patternName, patternConfig}
                urlHandler.sendRegexCreateRequest(data, (resp, status) => {
                    if (status != 200 || (resp && resp.code != 200)) {
                        let error = decodeURIComponent(resp.details);
                        error = error ? error.substring(error.indexOf('-')+1).trim() : '';
                        error = (error === undefined || error === 'undefined') ? '' : error;
                        if (!error && status == 504) {
                            error ='FFT Gateway timed out. Contact your administrator. Please try again later.' 
                        }
                        else if(!error) {
                            error = 'There was an error creating the RegEx entity. Please try again later.';
                        }  
                        this.setState({
                            error,
                            creating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })   
                    } else {
                        this.close(false);
                    }
                });
            } else {
                this.setState({
                    error: 'There are errors below.',
                    creating: false
                }, () => {
                    this.onScrollTo('err_msg');
                })
            }
        });
    }

    onReset(cancelled=true) {
        this.close(cancelled);
    }

    onScrollTo(anchor) {
        document.getElementById(anchor).scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    render() {

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '0',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                paddingBottom: '5px',
                transform   : 'translate(-50%)',
                maxWidth    : '70%',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }
        return (
            <div id="rm_CustomEntityCreateDialog">
                <ReactModal ref="createId" 
                    isOpen={this.props.show}
                    contentLabel="Create Custom Entity"
                    onRequestClose={this.close} 
                    style={styles}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={1000}>
                    <div className="kbedit">
                        <div className="kbedit-header">
                            <span className="header-text">Create Custom RegEx</span>
                        </div> 

                        <div className="kbedit-content" style={{maxHeight: `${this.state.height}px`}}>

                        <div className="kbedit-controls-wrapper">
                            <div className="kbedit-static-menu">
                                {/* using tooltips is bad for accessiblity consider adding alt tags as well */}
                                <span data-tip data-for="patternName" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_pattern_name')}}>Pattern Name</span><br/>
                                <ReactTooltip id="patternName" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        The name for the RegEx pattern. This is used to identify the pattern and must be unique.
                                </ReactTooltip>

                                <span data-tip data-for="entityType" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_entity_type')}}>Entity Type</span><br/>
                                <ReactTooltip id="entityType"  
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        The entity's type, can be a Finch entity type or a custom one.<br/>
                                        Can only contain capital leters, "_" and "/".<br/>
                                        Type must start and end with letter(s). <br/>
                                        "/" and "_" must be immediately preceded and followed by letter(s).
                                </ReactTooltip>

                                <span data-tip data-for="action" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_description')}}>Description</span><br/>
                                <ReactTooltip id="action" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        A descriptive note for the user, it is never exposed in the output.
                                </ReactTooltip>

                                <span data-tip data-for="label" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_confidence')}}>Extraction Confidence</span><br/>
                                <ReactTooltip id="label" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">
                                        The static extraction score for any match with this pattern.<br/>
                                        Entities with higher confidence will effectively overide those with lower confidence.
                                </ReactTooltip>

                                <span data-tip data-for="pattern" className="fa fa-info-circle">&nbsp;</span><span onClick={() => {this.onScrollTo('bm_pattern')}}>RegEx Pattern</span><br/>
                                <ReactTooltip id="pattern" 
                                        type="dark"
                                        effect="solid" 
                                        place="right">	
                                        The regular expression pattern to match. This must meet RE2 standards. 
                                </ReactTooltip>
                            </div>
                            <div className="kbedit-controls-list">
                                {this.state.error &&
                                    <div className="kbedit-error" id="err_msg">
                                        {this.state.error || ''}
                                    </div>
                                }

                                <FieldGroup
                                    control={this.myForm}
                                    render={({ pristine, value, invalid}) => (
                                        <div className="kbedit-nav-items">
                                            <div id="bm_pattern_name">
                                                <FieldControl name='patternName' render={renderers.textBox} meta={{label: 'Pattern Name', placeholder: 'Enter Text'}}/>
                                            </div>
                                            <div id="bm_entity_type">
                                                <FieldControl name='entityType' render={renderers.textBox} meta={{label: 'Entity Type', placeholder: 'Enter Text' }}/>
                                            </div>
                                            <div id="bm_description">
                                                <FieldControl name='description' render={renderers.textBox} meta={{label: 'Description', placeholder: 'Enter Text'}}/>
                                            </div>
                                            <div id="bm_confidence">
                                                <FieldControl name='extractionConfidence' render={renderers.rangeSlider} meta={{label: 'Extraction Confidence'}}/>
                                            </div>
                                            <div id="bm_pattern">
                                                {/* <FieldControl name='pattern' render={renderers.textBox} meta={{label: 'RegEx Pattern', placeholder: 'Enter Pattern'}}/> */}
                                                <FieldControl name='pattern' 
                                                    render={renderers.regExPatternArea} 
                                                    meta={{
                                                        onChange:(e)=>this.myForm.get('pattern').setValue(e.target.value.replace(/[\r\n\v]+/g, '')),
                                                        sublabel: 'Pattern',
                                                        resize:'none',
                                                        placeholder: 'Enter Pattern',
                                                        height: '200px',
                                                        padding: '0px',
                                                        expandable: false
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>

                        </div>
                        <div className="kbedit-footer">
                            {this.state.creating ? <CreateProgress /> : null}
                            <button type="button" className="kbedit-default-button" onClick={this.onSubmit}>Create</button>
                            <button type="button" className="kbedit-default-button" onClick={this.onReset}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

CustomEntityCreateDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    onCreate: PropTypes.func
};

export default CustomEntityCreateDialog;


